// src/formatCurrency.ts
function formatCurrency(value, currency = "USD", locale = "en-US") {
  if (value == null || isNaN(value)) return "";
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}

// src/hexToRgba.ts
function hexToRgba(hex, alpha) {
  let clean = hex.replace("#", "");
  if (clean.length === 3) {
    clean = clean.split("").map((c) => c + c).join("");
  }
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// src/generateUniqueId.ts
function generateUniqueId(prefix) {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).slice(2);
  const id = `${timestamp}${random}`;
  return prefix ? `${prefix}_${id}` : id;
}
export {
  formatCurrency,
  generateUniqueId,
  hexToRgba
};
